interface ApiErrorPayload {
  message?: string;
  error_origin?: 'integracao' | 'aplicacao' | string;
  integration_provider?: string;
  code?: string;
  error?: string | Record<string, string[]>;
  errors?: Record<string, string[]>;
  data?: Record<string, unknown>;
}

interface ParsedApiError {
  title: string;
  description: string;
  origin?: string;
  integrationProvider?: string;
  code?: string;
}

function getValidationMessage(errors?: Record<string, string[]>): string | undefined {
  if (!errors) return undefined;

  const firstField = Object.keys(errors)[0];
  if (!firstField || !Array.isArray(errors[firstField])) return undefined;

  return errors[firstField][0];
}

export default function parseApiError(
  rawError: unknown,
  fallbackMessage = 'Ocorreu um erro ao processar a requisição.',
): ParsedApiError {

  const payload = (rawError as { response?: { data?: ApiErrorPayload } })?.response
    ?.data;

  const message =
    payload?.message || getValidationMessage(payload?.errors) || fallbackMessage;

  if (payload?.error_origin === 'integracao') {
    const provider = payload.integration_provider;

    return {
      title: 'Erro de integração',
      description: provider ? `${message} (${provider})` : message,
      origin: payload.error_origin,
      integrationProvider: provider,
      code: payload.code,
    };
  }

  let errorDetail: string | undefined;
  if (payload?.error !== undefined) {
    errorDetail = typeof payload.error === 'string'
      ? payload.error
      : getValidationMessage(payload.error);
  }

  const description =
    payload?.error_origin === 'aplicacao' && errorDetail
      ? `${message}\n${errorDetail}`
      : message;

  return {
    title: 'Atenção',
    description,
    origin: payload?.error_origin,
    integrationProvider: payload?.integration_provider,
    code: payload?.code,
  };
}
